import React, { useRef, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

const NextPreviousButton = styled.button`
    width: ${({ vertical }) => (vertical ? '100%' : 'inherit')};
    font-size: 34px;
    position: absolute;
    z-index: 2;

    .arrow-icon {
        width: 34px;
        height: 34px;
        border-radius: 50%;
    }
`

export const NextButton = styled(NextPreviousButton)`
    ${({ vertical }) => {
        if (vertical) {
            return css`
                bottom: 40px;
                left: 50%;
                transform: translateX(-50%);
            `
        }
        return css`
            right: 0px;
            top: 50%;
            transform: translateY(-50%);
            padding-right: 10px;

            .arrow-icon {
                color: white;
                transform: rotate(-90deg);
            }
        `
    }}
`

export const PreviousButton = styled(NextPreviousButton)`
    ${({ vertical }) => {
        if (vertical) {
            return css`
                top: 40px;
                left: 50%;
                transform: translateX(-50%);
            `
        }
        return css`
            left: 0px;
            top: 50%;
            transform: translateY(-50%);
            padding-left: 10px;

            .arrow-icon {
                color: white;
                transform: rotate(-90deg);
            }
        `
    }}
`
